import {ROOT_URL} from "./global";
import {lazy} from "react";
import {Navigate} from "react-router-dom";
import {Redirect} from "../components";

const Dashboard = lazy(() => import("../pages/dashboard"));
const AddExpertise = lazy(() => import("../pages/add-expertise"));
const EditExpertise = lazy(() => import("../pages/edit-expertise"));
const Orders = lazy(() => import("../pages/orders"));
const UploadCenter = lazy(() => import("../pages/upload-center"));
const UploadProjectFile = lazy(() => import("../pages/upload-project-file"));
const Archive = lazy(() => import("../pages/archive"));
const Notifications = lazy(() => import("../pages/notifications"));
const Profile = lazy(() => import("../pages/profile/profile"));
const LandingInfo = lazy(() => import("../pages/profile/landing-info"));
const Portfolio = lazy(() => import("../pages/profile/portfolio"));
const AddPortfolio = lazy(() => import("../pages/profile/add-portfolio"));
const EditPortfolio = lazy(() => import("../pages/profile/edit-portfolio"));
const AccountInfo = lazy(() => import("../pages/profile/account-info"));
const MyFaq = lazy(() => import("../pages/profile/my-faq"));
const Testimonials = lazy(() => import("../pages/profile/testimonials"));
const Faults = lazy(() => import("../pages/profile/faults"));
const Services = lazy(() => import("../pages/profile/services"));
const AddService = lazy(() => import("../pages/profile/add-service"));
const EditService = lazy(() => import("../pages/profile/edit-service"));
const Authentication = lazy(() => import("../pages/authentication"));
const Financial = lazy(() => import("../pages/financial/financial"));
const TransactionHistory = lazy(() => import("../pages/financial/transaction-history"));
const CreditCard = lazy(() => import("../pages/financial/credit-card"));
const Wallet = lazy(() => import("../pages/financial/wallet"));
const Support = lazy(() => import("../pages/support/support"));
const MyTickets = lazy(() => import("../pages/support/my-tickets"));
const TicketInfo = lazy(() => import("../pages/support/ticket-info"));
const NewTicket = lazy(() => import("../pages/support/new-ticket"));
const Guide = lazy(() => import("../pages/guide"));
const Settings = lazy(() => import("../pages/settings"));
const ChatBox = lazy(() => import("../pages/chat-box"));
const NotFound = lazy(() => import("../pages/not-found"));

export const SIDEBAR_ROUTES = [
    {
        key: "dashboard",
        element: <Dashboard />,
        index: true,
        url: ROOT_URL + "/dashboard",
        path: "dashboard",
        title: "داشبورد من",
        iconClass: "icon-home",
        hasNotification: false,
        notificationClass: "",
        activeInMenu: false,
        showInMenu: true,
        subMenu: []
    },
    {
        key: "dashboard",
        element: <Navigate to={ROOT_URL+"/dashboard"} replace />,
        index: true,
        url: ROOT_URL + "/",
        path: "",
        title: "داشبورد من",
        iconClass: "",
        hasNotification: false,
        notificationClass: "",
        activeInMenu: false,
        showInMenu: false,
        subMenu: []
    },
    {
        key: "profile",
        element: <Profile /> ,
        url: ROOT_URL + "/profile",
        path: "profile",
        title: "پروفایل من",
        iconClass: "icon-verified-badge",
        hasNotification: false,
        notificationClass: "",
        activeInMenu: false,
        showInMenu: true,
        subMenu: [
            {
                key: "account-info",
                element: <AccountInfo />,
                url: ROOT_URL + "/profile/account-info",
                path: "profile/account-info",
                title: "اطلاعات شخصی",
            },
            {
                key: "landing-info",
                element: <LandingInfo />,
                url: ROOT_URL + "/profile/landing-info",
                path: "profile/landing-info",
                title: "اطلاعات لندینگ",
            },
            {
                key: "portfolio",
                element: <Portfolio />,
                url: ROOT_URL + "/profile/portfolio",
                path: "profile/portfolio",
                title: "نمونه کارهای من",
            },
            {
                key: "my-services",
                element: <Services />,
                url: ROOT_URL + "/profile/my-services",
                path: "profile/my-services",
                title: "خدمات من",
            },
            {
                key: "my-faq",
                element: <MyFaq />,
                url: ROOT_URL + "/profile/my-faq",
                path: "profile/my-faq",
                title: "سوالات متداول من",
            },
            {
                key: "testimonials",
                element: <Testimonials />,
                url: ROOT_URL + "/profile/testimonials",
                path: "profile/testimonials",
                title: "توصیه‌های کارفرمایان",
            },
            {
                key: "faults",
                element: <Faults />,
                url: ROOT_URL + "/profile/faults",
                path: "profile/faults",
                title: "تخلفات",
            }
        ]
    },
    {
        key: "portfolio-add",
        element: <AddPortfolio />,
        url: ROOT_URL + "/profile/portfolio/add",
        path: "profile/portfolio/add",
        title: "افزودن پورتفولیو",
        iconClass: "",
        hasNotification: false,
        notificationClass: "",
        activeInMenu: false,
        showInMenu: false,
        subMenu: []
    },
    {
        key: "portfolio-edit",
        element: <EditPortfolio />,
        url: ROOT_URL + "/profile/portfolio/edit/:portfolio_id",
        path: "profile/portfolio/edit/:portfolio_id",
        title: "ویرایش پورتفولیو",
        iconClass: "",
        hasNotification: false,
        notificationClass: "",
        activeInMenu: false,
        showInMenu: false,
        subMenu: []
    },
    {
        key: "my-services-add",
        element: <AddService />,
        url: ROOT_URL + "/profile/my-services/add",
        path: "profile/my-services/add",
        title: "افزودن خدمت",
        iconClass: null,
        hasNotification: false,
        notificationClass: "",
        activeInMenu: false,
        showInMenu: false,
        subMenu: []
    },
    {
        key: "my-services-edit",
        element: <EditService />,
        url: ROOT_URL + "/profile/my-services/edit/:service_id",
        path: "profile/my-services/edit/:service_id",
        title: "ویرایش خدمت",
        iconClass: null,
        hasNotification: false,
        notificationClass: "",
        activeInMenu: false,
        showInMenu: false,
        subMenu: []
    },
    {
        key: "chat-box",
        element: <ChatBox />,
        url: ROOT_URL + "/chat-box",
        path: "chat-box",
        title: "چت باکس پروژه‌ها",
        iconClass: "icon-chat",
        hasNotification: "unread_chats",
        notificationClass: "notify-shadow-green",
        activeInMenu: false,
        showInMenu: true,
        subMenu: []
    },
    {
        key: "orders",
        element: <Orders />,
        url: ROOT_URL + "/orders",
        path: "orders",
        title: "سفارشات",
        iconClass: "icon-double-file",
        hasNotification: false,
        notificationClass: "",
        activeInMenu: false,
        showInMenu: true,
        subMenu: []
    },
    {
        key: "financial",
        element: <Financial />,
        url: ROOT_URL + "/financial",
        path: "financial",
        title: "امور مالی",
        iconClass: "icon-folder",
        hasNotification: false,
        notificationClass: "",
        activeInMenu: null,
        showInMenu: true,
        subMenu: [
            {
                key: "wallet",
                element: <Wallet />,
                url: ROOT_URL + "/financial/wallet",
                path: "financial/wallet",
                title: "کیف پول",
            },
            {
                key: "credit-card",
                element: <CreditCard />,
                url: ROOT_URL + "/financial/credit-card",
                path: "financial/credit-card",
                title: "کارت بانکی",
            },
            {
                key: "transaction-history",
                element: <TransactionHistory />,
                url: ROOT_URL + "/financial/transaction-history",
                path: "financial/transaction-history",
                title: "تاریخچه تراکنش‌ها",
            },
        ]
    },
    {
        key: "support",
        element: <Support />,
        url: ROOT_URL + "/support",
        path: "support",
        title: "پشتیبانی",
        iconClass: "icon-ticket text-sm",
        hasNotification: false,
        notificationClass: "",
        activeInMenu: null,
        showInMenu: true,
        subMenu: [
            {
                key: "faq",
                element: <Redirect url={process.env.REACT_APP_MAIN_URL+"/faq/freelancer"} />,
                url: ROOT_URL + "/support/faq",
                path: "support/faq",
                title: "سوالات متداول",
            },
            {
                key: "my-tickets",
                element: <MyTickets />,
                url: ROOT_URL + "/support/my-tickets",
                path: "support/my-tickets",
                title: "تیکت‌های من",
            },
            {
                key: "new-ticket",
                element: <NewTicket />,
                url: ROOT_URL + "/support/new-ticket",
                path: "support/new-ticket",
                title: "ارسال تیکت جدید",
            },
        ]
    },
    {
        key: "my-tickets-single",
        element: <TicketInfo />,
        url: ROOT_URL + "/support/my-tickets/:ticket_id",
        path: "support/my-tickets/:ticket_id",
        title: "تیکت",
        iconClass: null,
        hasNotification: false,
        notificationClass: "",
        activeInMenu: null,
        showInMenu: false,
        subMenu: []
    },
    {
        key: "settings",
        element: <Settings />,
        url: ROOT_URL + "/settings",
        path: "settings",
        title: "تنظیمات",
        iconClass: "icon-setting",
        hasNotification: false,
        notificationClass: "",
        activeInMenu: null,
        showInMenu: true,
        subMenu: []
    },
    {
        key: "add-expertise",
        element: <AddExpertise />,
        url: ROOT_URL + "/add-expertise",
        path: "add-expertise",
        title: "افزودن تخصص",
        iconClass: null,
        hasNotification: false,
        notificationClass: "",
        activeInMenu: null,
        showInMenu: false,
        subMenu: []
    },
    {
        key: "archive",
        element: <Archive />,
        url: ROOT_URL + "/archive",
        path: "archive",
        title: "رزومه من", //آرشیو
        iconClass: "icon-plus text-sm",
        hasNotification: false,
        notificationClass: "",
        activeInMenu: null,
        showInMenu: true,
        subMenu: []
    },
    {
        key: "notifications",
        element: <Notifications />,
        url: ROOT_URL + "/notifications",
        path: "notifications",
        title: "اعلانات",
        iconClass: "icon-bell",
        hasNotification: "unread_notifications",
        notificationClass: "notify-shadow-red",
        activeInMenu: null,
        showInMenu: true,
        subMenu: []
    },
    {
        key: "guide",
        element: <Guide />,
        url: ROOT_URL + "/guide",
        path: "guide",
        title: "راهنما",
        iconClass: "icon-hollow-question-mark",
        hasNotification: false,
        notificationClass: "",
        activeInMenu: false,
        showInMenu: true,
        subMenu: []
    },
    {
        key: "upload-center",
        element: <UploadCenter />,
        url: ROOT_URL + "/upload-center/:project_id",
        path: "upload-center/:project_id",
        title: "آپلود سنتر",
        iconClass: null,
        hasNotification: false,
        notificationClass: "",
        activeInMenu: false,
        showInMenu: false,
        subMenu: []
    },
    {
        key: "upload",
        element: <UploadProjectFile />,
        url: ROOT_URL + "/upload-center/upload/:project_id",
        path: "upload-center/upload/:project_id",
        title: "آپلود سنتر",
        iconClass: null,
        hasNotification: false,
        notificationClass: "",
        activeInMenu: false,
        showInMenu: false,
        subMenu: []
    },
    {
        key: "expertise-edit",
        element: <EditExpertise />,
        url: ROOT_URL + "/edit-expertise/:expertise_id",
        path: "edit-expertise/:expertise_id",
        title: "ویرایش تخصص",
        iconClass: null,
        hasNotification: false,
        notificationClass: "",
        activeInMenu: null,
        showInMenu: false,
        subMenu: []
    },
    {
        key: "authentication",
        element: <Authentication />,
        url: ROOT_URL + "/authentication",
        path: "authentication",
        title: "احراز هویت",
        iconClass: null,
        hasNotification: false,
        notificationClass: "",
        activeInMenu: null,
        showInMenu: false,
        subMenu: []
    },
    {
        key: "not-found",
        element: <NotFound />,
        url: ROOT_URL + "/404",
        path: "404",
        title: "۴۰۴ پیدا نشد",
        iconClass: null,
        hasNotification: false,
        notificationClass: "",
        activeInMenu: false,
        showInMenu: false,
        subMenu: []
    },
];
